import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
// import gsap from "gsap"; // CDN版を使用
import { ScrollTrigger } from "gsap/ScrollTrigger"; // CDN版を使用
import { ScrollToPlugin } from "gsap/ScrollToPlugin"; // CDN版を使用
import topValidation from 'top-validation';
import '@/scss/design.scss';



let lenis;

document.addEventListener('DOMContentLoaded', () => {
  // プラグイン登録は1回でOK
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  // ページローディング
  pageLoading();

  // Lenis設定
  lenis = new Lenis();
  lenis.on('scroll', ScrollTrigger.update);
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);


});

// common.js の中身
window.addEventListener("load", function() { // 画像などのリソースが全部読み込まれてから実行
  
  gsap.registerPlugin(ScrollTrigger);

  // 念のため要素が存在するかチェック
  if (document.querySelector(".golf_img img")) {
    gsap.to(".golf_img img", {
      yPercent: -20,
      ease: "none",
      scrollTrigger: {
        trigger: ".golf_img",
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
      }
    });
  }

  // フェードインの動き
  gsap.utils.toArray('.js-fadein').forEach((item) => {
    gsap.set(item, {
      autoAlpha: 0,
      y: 100,
    });
    gsap.to(item, {
      autoAlpha: 1,
      y: 0,
      duration: 0.8,
      scrollTrigger: {
        trigger: item,
        start: 'top 80%',
      }
    });
  });

});

  if (document.body.classList.contains('contact')) {
    topValidation(); 
  }


document.addEventListener('DOMContentLoaded', () => {
  const active = 'is-active';
  document.querySelector('.btn-trigger').addEventListener('click', function() {
    this.classList.toggle(active);
    document.querySelector('.hd_nav_wrap').classList.toggle(active);
  });
});


/*-------------------------------------------------------------------------------
  スクロール　ヒント
--------------------------------------------------------------------------------*/
window.addEventListener('DOMContentLoaded', function () {
  new ScrollHint('.js-scrollable', {
    scrollHintIconAppendClass: 'scroll-hint-icon-white', 
    suggestiveShadow: false,
    i18n: {
      scrollable: "スクロールできます"
    }
  });
});


/*-------------------------------------------------------------------------------
  スムーススクロール
--------------------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault();
      const href = anchor.getAttribute('href');
      const target = href === '#' || href === '' ? document.documentElement : document.querySelector(href);
      if (target && lenis) {
        lenis.scrollTo(target, { duration: 1 });
      }
    });
  });
});


/*-------------------------------------------------------------------------------
  Contact Form 7 拡張プラグイン対応：遷移・スクロール制御
--------------------------------------------------------------------------------*/

// 1. スクロール実行関数（Lenis / GSAP 両対応）
const executeScroll = (selector) => {
  const target = document.querySelector(selector);
  const headerHeight = document.querySelector('.header')?.offsetHeight || 0;

  if (target) {
    // 確実に Lenis が初期化されているか確認
    if (typeof lenis !== 'undefined' && lenis !== null) {
      lenis.scrollTo(target, {
        offset: -headerHeight,
        duration: 1.2,
        immediate: false
      });
    } else {
      // LenisがなければGSAPで実行
      gsap.to(window, {
        duration: 1,
        scrollTo: { y: selector, offsetY: headerHeight },
        ease: "power2.inOut"
      });
    }
  }
};

// 2. 遷移後のハッシュ判定（thanksページ読み込み時）
window.addEventListener('load', () => {
  // プラグインが自動で slug:contact_thanks へ飛ばす際、
  // URLにハッシュがつかない場合があるため、URL自体に contact_thanks が含まれるかも判定
  if (window.location.hash === '#scroll' || window.location.pathname.includes('contact_thanks')) {
    // ページの描画とLenisの初期化を待つため、少し長めに待機
    setTimeout(() => {
      executeScroll('#thanks-anchor');
    }, 400);
  }
});

// 3. 確認画面ボタンやバリデーションエラー時のスクロール
// プラグイン独自のイベント 'wpcf7confirm' (もしあれば) や 標準イベントに反応
document.addEventListener('wpcf7invalid', () => {
  setTimeout(() => executeScroll('.contact_form_unit'), 100);
}, false);

// 4. プラグインの「確認画面」ボタンが押された時のスクロール
document.addEventListener('click', (e) => {
  if (e.target.closest('.confirm-none')) {
    setTimeout(() => executeScroll('#form-confirm'), 200);
  }
  if (e.target.closest('.back')) {
    setTimeout(() => executeScroll('#form-input'), 200);
  }
});